import type { PrivateEventCrewView } from '../../api/privateEvents';
import { useViewport } from '../../hooks/useViewport';

import PrivateEventCrewSection from './PrivateEventCrewSection';
import TeacherPrivateEventDetailsCard from './TeacherPrivateEventDetailsCard';

/** The admin detail page's layout for a teacher: the details on the left and
 *  the crew on the right. It leaves out the change history, which teachers
 *  cannot read, and the import banner, which asks the reader to fill in gaps. */
export default function TeacherPrivateEventBody({ event }: { event: PrivateEventCrewView }) {
  const { isDesktop } = useViewport();

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: isDesktop ? '1.55fr 1fr' : '1fr',
        gap: 16,
        alignItems: 'start',
      }}
    >
      <TeacherPrivateEventDetailsCard event={event} />
      <PrivateEventCrewSection event={event} viewOnly />
    </div>
  );
}
